<template>
  <Subtitle>
    <template #text>
      <div :class="{ 'full-width': titleFullWidth }" class="vx-custom-title">
        {{ title }}
      </div>
    </template>
    <template #side>
      <Tooltip
        v-for="(icon, index) in icons"
        :key="index"
        :bottom="tooltipBottom"
        :left="tooltipLeft"
      >
        <template #element>
          <Icon
            class="mx-1"
            :width="iconSize"
            :height="iconSize"
            :exp-active="true"
            :icon="icon.icon_name"
          />
        </template>
        <template #title>
          {{ icon.icon_title[0].text }}
        </template>
        {{ icon.icon_description[0].text }}
      </Tooltip>
      <Button
        v-if="button1.text"
        class="first-button"
        shape="outline"
        size="small"
        font-size="13"
        color="white"
        text="gray"
        :hover="button1.color"
        :to="$trailingSlash(localePath(button1.link))"
      >
        {{ button1.text }}
      </Button>
      <Button
        v-if="button2.text"
        class="mx-1"
        shape="outline"
        size="small"
        font-size="13"
        color="white"
        text="gray"
        :hover="button2.color"
        :to="$trailingSlash(localePath(button2.link))"
      >
        {{ button2.text }}
      </Button>
      <BadgeNew v-if="showNewTag" class="mx-1" />
    </template>
  </Subtitle>
</template>

<script>
import Subtitle from '@/components/Home/Subtitle';
import Button from 'UI/Button';
import BadgeNew from 'UI/Badges/New';

import Icon from 'UI/Icon';
import Tooltip from '@/components/Common/Tooltip';

export default {
  components: {
    Button,
    Tooltip,
    Subtitle,
    Icon,
    BadgeNew
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ids: [],
      name: '',
      title: '',
      button1: {},
      button2: {},
      iconSize: 35,
      tooltipBottom: 145,
      tooltipLeft: 21,
      icons: [],
      showNewTag: false
    };
  },
  fetch() {
    this.title = this.slice.primary?.title1[0]?.text;

    let buttonText = this.slice.primary.button1_text[0];
    if (buttonText?.text) {
      this.button1 = {
        text: buttonText.text,
        link: this.slice.primary.button1_link[0] ? this.slice.primary?.button1_link[0]?.text : '',
        color: this.slice.primary.button1_hover_color
      };
    }

    buttonText = this.slice.primary.button2_text[0];
    if (buttonText?.text) {
      this.button2 = {
        text: buttonText.text,
        link: this.slice.primary.button2_link[0] ? this.slice.primary?.button2_link[0]?.text : '',
        color: this.slice.primary.button2_hover_color
      };
    }
    this.icons = this.slice.items.filter((item) => item.icon_name);
    this.showNewTag = this.slice.primary.show_new_tag;
  },
  computed: {
    titleFullWidth() {
      return (
        (this.button1.text && this.button2.text) ||
        this.icons.length > 1 ||
        (this.showNewTag && (this.icons.length || this.button1.text || this.button2.text))
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.first-button {
  margin: 0 5px;
  @include sm {
    margin-left: 0;
  }
}
.full-width {
  @include sm {
    width: calc(100vw - 60px);
  }
}
.vx-custom-background .vx-custom-title {
  color: white;
}
</style>
